import IllustrationPreview36 from 'assets/images/iconPackPreviews/36_bold_office.png';
import IllustrationPreview37 from 'assets/images/iconPackPreviews/37_mustard.png';
import IllustrationPreview38 from 'assets/images/iconPackPreviews/38_presentations.png';
import IllustrationPreview39 from 'assets/images/iconPackPreviews/39_analytics.png';
import IllustrationPreview40 from 'assets/images/iconPackPreviews/40_simple_illust.png';
import { UserTypes } from 'modules/User';

export const MOCK_ICON_PACK_DATA = [
  {
    id: 1,
    name: 'Activities and Interactions',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Business,
    order: 20,
    displayIconIds: [
      'ui_banners_people_man_having_a_drink_at_the_bar',
      'ui_banners_people_older_man_with_walking_stick_2',
      'ui_banners_people_man_throwing_paper_airplane',
      'ui_banners_people_photographer_with_camera',
      'ui_banners_people_film_director',
      'ui_banners_people_man_travelling',
      'ui_banners_people_man_standing',
      'ui_banners_people_man_serving_food',
      'ui_banners_christmas_elements_working_santa',
      'ui_banners_people_cool_guy',
    ],
  },
  {
    id: 2,
    name: 'Cultural Pack',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 24,
    displayIconIds: [
      'germany_house2',
      'canada_snowflake2',
      'thailand_lotus2',
      'spain_paella2',
      'thailand_coconut2',
      'canada_hat2',
      'chile_cultrun2',
      'germany_pretzel2',
      'chille_moai2',
      'thailand_temple2',
    ],
  },
  {
    id: 3,
    name: 'Cultural Mono',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 32,
    displayIconIds: [
      'canada_hat',
      'chile_empanada',
      'canada_syrup',
      'thailand_temple',
      'chile_avocado',
      'thailand_stupa',
      'spain_wine',
      'chile_cultrun',
      'spain_cathedral',
      'canada_hockey',
    ],
  },
  {
    id: 4,
    name: 'Retro Essentials',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 8,
    displayIconIds: [
      'ricon-pan',
      'ricon-female-gender',
      'ricon-presentation-video-audio',
      'ricon-trash-14',
      'ricon-bookmark-crate',
      'ricon-identification-badge',
      'ricon-eraser-graphic-design-tools',
      'ricon-holed-document',
      'ricon-location-map',
      'ricon-delete-shopping-cart',
    ],
  },
  {
    id: 5,
    name: 'Travel Work Activities',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Business,
    order: 27,
    displayIconIds: [
      'ui_banners_christmas_santa_claus_putting_presents_under_the_tree',
      'ui_banners_technology_collaboration_on_design_like_the_blue_website_header',
      'ui_banners_airport_people_checking_departure_board_waiting_for_their_flight',
      'ui_banners_airport_passport_control',
      'ui_banners_airport_many_nationalities_walking_across_with_their_bags',
      'ui_banners_shopping_man_paying_at_cashier',
    ],
  },
  {
    id: 6,
    name: 'Diverse Circular Portraits',
    isDiverse: true,
    isMono: false,
    permission: UserTypes.Business,
    order: 2,
    displayIconIds: [
      'flat_icons_scenes_interactions_and_communication_chat_skin5',
      'gradient_icons_dating_badge_sunglasses_woman_skin2',
      'gradient_icons_dating_badge_sunglasses_man_skin4',
      'flat_icons_scenes_activities_woman_bowling_skin3',
      'flat_icons_scenes_activities_man_bowling_skin3',
      'flat_icons_scenes_home_sitting_by_the_fireplace_skin1',
      'flat_icons_scenes_home_reading_woman_skin4',
      'gradient_icons_fitness_flip_flop_skin5',
      'gradient_icons_dating_badge_messaging_skin3',
      'gradient_icons_shopping_take_photoes_of_shopping_items_skin4',
    ],
  },
  {
    id: 7,
    name: '2D Faces',
    isDiverse: true,
    isMono: false,
    permission: UserTypes.Premium,
    order: 16,
    displayIconIds: [
      'anatomy_child2_skin2',
      'anatomy_child1_skin3',
      'oldwoman5_skin1',
      'simple_avatarf11_skin4',
      'oldwoman2_skin1',
      'oldwoman1_skin5',
      'avatarm8_skin1',
      'engineer1_skin2',
      'meditating_woman_skin3',
      'disability9_skin2',
    ],
  },
  {
    id: 8,
    name: 'Circular Portraits',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Business,
    order: 23,
    displayIconIds: [
      'gradient_icons_shopping_browse_but_never_buy',
      'gradient_icons_travel_light_hunt',
      'gradient_icons_travel_travel_via_sea',
      'gradient_icons_travel_show_it_off',
      'gradient_icons_travel_airmiles_reward',
      'gradient_icons_travel_kilimanjaro',
      'gradient_icons_travel_japan',
      'gradient_icons_travel_backpacker',
      'gradient_icons_travel_as_long_as_there_is_a_roof',
      'gradient_icons_travel_grab_the_cabs',
    ],
  },
  {
    id: 15,
    name: 'Meme Icons',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 21,
    displayIconIds: [
      'meme_this_is_fine_dog',
      'meme_surprised_shocked_pikachu',
      'meme_awkward_look_monkey_puppet',
      'meme_patrick_i_have_3_dollars',
      'meme_norton_smirking',
      'meme_sad_frog',
      'meme_ralph_wiggum_diving_through_window',
      'meme_handsome_squidward',
      'meme_kermit_not_my_business',
      'meme_homer_simpson_bushes',
    ],
  },
  {
    id: 16,
    name: 'WFH People & Pets',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 9,
    displayIconIds: [
      'wfh_pets_black_nonbinary_person_on_laptop_with_dog',
      'wfh_pets_asian_woman_on_laptop_with_cat',
      'wfh_pets_white_man_on_laptop_with_hamster',
      'wfh_pets_black_nonbinary_person_on_laptop',
      'wfh_pets_asian_woman_on_laptop',
      'wfh_pets_white_man_on_laptop',
      'wfh_pets_standing_black_dog_with_headset',
      'wfh_pets_standing_black_dog',
      'wfh_pets_standing_brown_dog',
      'wfh_pets_standing_brown_white_spots_dog',
    ],
  },
  {
    id: 17,
    name: 'Detailed Faces',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 28,
    displayIconIds: [
      'diverse_people_nonbinary_red_short_hair_skin2',
      'diverse_people_woman_curly_long_hair_skin5',
      'diverse_people_girl_ponytails_skin1',
      'diverse_people_man_senior_beard_skin3',
      'diverse_people_boy_curly_hair_skin4',
      'diverse_people_woman_native_indigenous_braids_skin2',
      'diverse_people_nonbinary_lgbtq_blonde_skin1',
      'diverse_people_woman_pink_hair_glasses_skin5',
      'diverse_people_girl_red_braid_skin1',
      'diverse_people_man_native_indigenous_long_hair_skin4',
    ],
  },
  {
    id: 18,
    name: 'Decorative Shapes',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 4,
    displayIconIds: [
      'extra_shapes_promo_rounded_badge',
      'extra_shapes_promo_rounded_badge_octagon',
      'extra_shapes_promo_sharp_badge',
      'extra_shapes_promo_sharp_badge_decagon',
      'extra_shapes_promo_sharp_badge_octagon',
      'extra_shapes_simple_thick_star_sparkle',
      'extra_shapes_simple_thin_star_sparkle',
      'extra_shapes_four_clover_thick_connected_leaves',
      'extra_shapes_four_clover_thin_disconnected_leaves',
      'extra_shapes_four_clover_connected_cross_leaves',
    ],
  },
  {
    id: 19,
    name: 'Women Empowerment',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 10,
    displayIconIds: [
      'women_empowerment_hands_solidarity_skin1',
      'women_empowerment_hands_support_skin5',
      'women_empowerment_fist_power_skin1',
      'women_empowerment_fist_power_bracelet_skin5',
      'women_empowerment_fist_power_right_skin3',
      'women_empowerment_fist_power_group_skin2',
      'women_empowerment_flag_skin3',
      'women_empowerment_banner_skin5',
      'women_empowerment_poster_skin4',
      'women_empowerment_sign_skin1',
    ],
  },
  {
    id: 20,
    name: 'LGBTQ2S+ Pride',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 25,
    displayIconIds: [
      'lgbtq_pride_flag_rainbow',
      'lgbtq_pride_flag_progresspride_rainbow',
      'lgbtq_pride_waving_flag_rainbow',
      'lgbtq_pride_support_speech_rainbow',
      'lgbtq_pride_flag_love_rainbow',
      'lgbtq_pride_identity_hand_raised_skin2',
      'lgbtq_pride_support_fist_raised_skin3',
      'lgbtq_pride_flag_bisexual',
      'lgbtq_pride_waving_flag_bisexual',
      'lgbtq_pride_support_speech_bisexual',
    ],
  },
  {
    id: 32,
    name: 'Professions',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 30,
    displayIconIds: [
      'careers_people_woman_medical_doctor_skin4',
      'careers_people_man_medical_nurse_skin1',
      'careers_people_man_dentist_skin3',
      'careers_people_woman_vet_veterinarian_skin2',
      'careers_people_woman_senior_psychologist_skin5',
      'careers_people_man_paramedic_skin1',
      'careers_people_man_lab_tech_laboratory_technician_skin4',
      'careers_people_woman_engineer_architect_skin2',
      'careers_people_man_software_developer_skin3',
      'careers_people_woman_lawyer_skin5',
    ],
  },
  {
    id: 33,
    name: 'Technology',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 7,
    displayIconIds: [
      'modern_tech_apple_smart_watch',
      'modern_tech_airpods',
      'modern_tech_macbook_air_wallpaper',
      'modern_tech_macbook_air_blank',
      'modern_tech_imac_monitor_wallpaper',
      'modern_tech_imac_monitor_blank',
      'modern_tech_ipad_wallpaper',
      'modern_tech_ipad_blank',
      'modern_tech_iphone_wallpaper',
      'modern_tech_iphone_blank',
    ],
  },
  {
    id: 41,
    name: 'Science',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 31,
    displayIconIds: [
      'biosci_cell_type_immune_red_blood_cell_side_view',
      'biosci_cell_division_meiosis_metaphase_ii',
      'biosci_cell_type_immune_basophil',
      'biosci_cell_type_immune_lymphocyte_resident_memory',
      'biosci_cell_division_meiosis_anaphase_ii',
      'biosci_cell_type_epithelial_cholangiocyte_small',
      'biosci_cell_type_immune_platelet_non_active',
      'biosci_cell_division_meiosis_telophase_ii',
      'biosci_cell_division_meiosis_prophase_ii',
      'biosci_cell_type_immune_macrophage_phagocytosis',
    ],
  },
];

export const ICON8_PACK_DATA = [
  {
    category: 'social-networks',
    platform: 'fluent-systems-regular',
    id: 9,
    name: 'Social Media',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 3,
    isIcons8: true,
    displayIconIds: [
      '97E7Dm8qCE2w',
      'z1QKNkhNTYpo',
      '40wKfDQEJsd2',
      'og3NonlQeZ5g',
      '3iSDu4wTLpw2',
      '7WVpwSy9g6hn',
      'FOOSCXOgTsTF',
      '7Gc3zAVnhfkK',
      'BRElTmOLC6Bh',
      'Bl7OpOfLTo7F',
    ],
  },
  {
    category: 'business',
    platform: 'flat_round',
    id: 10,
    name: 'Infographic Business',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 5,
    isIcons8: true,
    displayIconIds: [
      'XN1LvWvQdODo',
      'pnV8VDmzQWzH',
      '81580',
      '81504',
      '81490',
      '81480',
      '81477',
      '81471',
      '81418',
      '81417',
    ],
  },
  {
    category: 'business',
    platform: 'nolan',
    id: 12,
    name: 'Simple Gradient',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 18,
    isIcons8: true,
    displayIconIds: [
      'Q4E4LKr3S5sP',
      'AfM2kzPzTz6Q',
      '6vgrr3Lqd2VN',
      '44798',
      '8aRfr1e1BjwV',
      '6q88zpoPgCAj',
      '5ZDqqbvHOkKs',
      '8MqrQIywEiYc',
      'O4UB7PWd986U',
      'vejcLnEC0H6B',
    ],
  },
  {
    category: 'healthcare',
    platform: 'fluent-systems-filled',
    id: 13,
    name: 'Healthcare Basics',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 6,
    isIcons8: true,
    displayIconIds: [
      '04UrLkmXKjJh',
      'XWqnpSmCXXFz',
      'aw5G4xAlHuSi',
      'YPHGVSBSeMWH',
      '8j5PdwEABwdO',
      'eD6uVdKOtF97',
      'DOkOcdQl69Gf',
      'oA062Rx4qvBs',
      'rBOmteSELnj1',
      'xlATAZUrRNFQ',
    ],
  },
  {
    category: 'business',
    platform: 'dotty',
    id: 14,
    name: 'Office Essentials',
    isDiverse: false,
    isMono: true,
    permission: UserTypes.Free,
    order: 1,
    isIcons8: true,
    displayIconIds: [
      'cK1fynR8tzXS',
      '101834',
      'dwXrV7cfl0yP',
      'gJdR1tIP4iy1',
      'LXIL6scI4jdy',
      '5b3YHrdAEQSu',
      'WAGpgfrE3f2y',
      'tRiN5GgdL63z',
      'hSZRefS9QZRh',
      'xE0wvp6IA7yM',
    ],
  },
  {
    category: '',
    platform: 'stickers',
    id: 21,
    name: 'Stickers',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 22,
    isIcons8: true,
    displayIconIds: [
      'PtTOdKCxWemm',
      'M2moOiK7Ce0N',
      'EdUi3CHSWgQQ',
      '67tg2TQBcKAM',
      'OnTnB2j4sP5M',
      'SfjHY6OVVFVz',
      '3Osw57w15Tjm',
      '9XSGUzqf4jLu',
      'OuYvdYPlPy2t',
      'z8adutWhsZyP',
    ],
  },
  {
    category: 'sports',
    platform: 'clouds',
    id: 22,
    name: 'Clouds',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 14,
    isIcons8: true,
    displayIconIds: [
      'b5Xi6gHXgfCr',
      'o4OuVcqGdT4U',
      'jy358Co50jA7',
      '8aixhgJfYKcS',
      't36Q7mOFSruf',
      'GskohaMdz7St',
      'NfFFeYKNI37K',
      'xFKNzeO45ub2',
      'QXAaal321iVS',
      'WtYChgK9Z05b',
    ],
  },
  {
    category: 'business',
    platform: 'bubbles',
    id: 23,
    name: 'Bubbles',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 11,
    isIcons8: true,
    displayIconIds: [
      'FiqzgeE17Fc7',
      'LD6Tb2xIHJgL',
      'iUFJ5F2noFUE',
      'stv28TbrVcoI',
      'd0Q6fXcETlmD',
      'FbQwYNq0op8d',
      'OfKXlxB4IrZ1',
      'igWZVRi7kPrf',
      'zqs-BqbN3Hbd',
      't8h2fK9dteU8',
    ],
  },
  {
    category: '',
    platform: 'pulsar-color',
    id: 24,
    name: 'Pulsar',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 26,
    isIcons8: true,
    displayIconIds: [
      'PpnZ6CqrlxT1',
      'her3SGxlqdeC',
      'mYLac1Z7svXx',
      'wWV8VydQJiFl',
      'QIjP4tfenMLf',
      'WjyoYvODNUE2',
      'Yu6V1Zjlh2CR',
      'Jq08rhiSiW7V',
      'BP0HOAe3tB0s',
      'HcwTkVo4KPQY',
    ],
  },
  {
    category: 'food',
    platform: 'arcade',
    id: 25,
    name: 'Food',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 25,
    isIcons8: true,
    displayIconIds: [
      'ivDuFMZjmGuh',
      'oOCdEyI1X3B3',
      'nPZZJMFFrxGE',
      '8hw6c72ar1iS',
      'QfEvgo0mlx32',
      'UBHeJykJXJLe',
      'fWsadhamEd9Z',
      'v75XF3clnN50',
      'j13ldwrFdRAU',
      '4ElzYEJEsCwa',
    ],
  },
  {
    category: 'user-interface',
    platform: 'ultraviolet',
    id: 27,
    name: 'Blue UI',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 12,
    isIcons8: true,
    displayIconIds: [
      '2INdxPlUrYa8',
      '7c4fbaVzuIQ6',
      'wasWYg8h3Xmv',
      'ZBL8mQveY4Pz',
      'wee01c4USYY0',
      '9VkfNmtS084I',
      'pbh6LNJSJXYt',
      'pk7f_sm4qXTK',
      'alXnSU3qX8ux',
      'SvdXQfEdfJaK',
    ],
  },
  {
    category: 'business',
    platform: 'dusk',
    id: 28,
    name: 'Pastels',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 13,
    isIcons8: true,
    displayIconIds: [
      'yg0Xl3Bazd07',
      '4nwxOAD9AHyv',
      'GmbGQ1vsCkWC',
      '46432',
      'DGgvyD1E4rCw',
      'VbINv0XXvK3n',
      'cGcRDueIKQkF',
      '6Iqs3oaGCgeJ',
      '_B9E72JD1gYO',
      'oQETyVB4tQaH',
    ],
  },
  {
    category: '',
    platform: 'parakeet',
    id: 29,
    name: 'Parakeet',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Premium,
    order: 29,
    isIcons8: true,
    displayIconIds: [
      'IHt0YyloqDdn',
      '2rMCHeRTv4sX',
      'vG4JM2Gcug99',
      'hsULTeT51Bnl',
      'ENAbEEP1Se7s',
      'iiQ8joWns9uh',
      '8V0TK1zxiQBR',
      '4OjWolQuXUIl',
      '7yznUjGJFbtd',
      'xCAhXhUHWSW4',
    ],
  },
  {
    category: 'business',
    platform: 'm_rounded',
    id: 34,
    name: 'Finance Mono',
    isDiverse: false,
    isMono: false,
    permission: UserTypes.Free,
    order: 15,
    isIcons8: true,
    displayIconIds: [
      'Aur9SWH3a9ye',
      'TVr1NBWbz0R0',
      'Ncm2EyOuoNRv',
      'cmndXsEn2Mqx',
      'kdi6nQ1tYpvn',
      'RKguMy5x5S94',
      '36UIdfGCVbij',
      'zgux9eomxqKF',
      '5mvL1aSrIRyL',
      'NEuNsHqondpg',
    ],
  },
];

export const ICONS8_ILLUSTRATION_PACK_DATA = [
  {
    id: 36,
    categories: ['technologies'],
    style: 'simplistic',
    isIcons8Illustration: true,
    permission: UserTypes.Free,
    order: 36,
    isMono: false,
    name: 'Bold Office',
    isDiverse: false,
    previewImg: IllustrationPreview36,
  },
  {
    id: 37,
    categories: ['occupation'],
    style: 'taxi',
    isIcons8Illustration: true,
    permission: UserTypes.Free,
    order: 37,
    isMono: false,
    name: 'Mustard',
    isDiverse: false,
    previewImg: IllustrationPreview37,
  },
  {
    id: 38,
    categories: ['business'],
    style: 'clip',
    isIcons8Illustration: true,
    permission: UserTypes.Free,
    order: 38,
    isMono: false,
    name: 'Presentations',
    isDiverse: false,
    previewImg: IllustrationPreview38,
  },
  {
    id: 39,
    categories: [],
    style: 'office',
    isIcons8Illustration: true,
    permission: UserTypes.Free,
    order: 17,
    isMono: false,
    name: 'Analytics',
    isDiverse: false,
    previewImg: IllustrationPreview39,
  },
  {
    id: 40,
    categories: ['technologies'],
    style: 'techny',
    isIcons8Illustration: true,
    permission: UserTypes.Free,
    order: 19,
    isMono: false,
    name: 'Simple Illustrations',
    isDiverse: false,
    previewImg: IllustrationPreview40,
  },
];

export const GATED_ICONS8_PLATFORMS = {
  [UserTypes.Premium]: ICON8_PACK_DATA.filter((pack) => pack.permission === UserTypes.Premium).map(
    (pack) => pack.platform,
  ),
};
